import { createApiHandler } from './handler';

const admins = {
  apiClient: null,
  path: '/admin/admins',

  setClient(apiClient) {
    this.apiClient = apiClient;
    this.initApiHandler();
  },

  initApiHandler() {
    Object.assign(this, createApiHandler(this.apiClient, this.path));
  },

};

export default admins;
